import { AdacButton, AdacHeadline } from '@adac-de/component-library';
import React from 'react';
import styles from './confirmation-screen.module.scss';
import { ConfirmationBox } from '@components/confirmation-box/confirmation-box';
import { FAQs } from '@components/faqs/faqs';

type ConfirmationScreenProps = {
  requestResponse: SolarApimPartnerList;
  resetWizard: () => void;
  faqs?: PvWizardSectionOffer['faqs'];
};

export const ConfirmationScreen: React.FC<ConfirmationScreenProps> = ({
  requestResponse,
  resetWizard,
  faqs
}) => (
  <>
    <AdacHeadline tagName="h1" styleAs="h0" className="margin-bottom--l">
      Ihre Angebots-Anfrage
    </AdacHeadline>
    <ConfirmationBox requestResponse={requestResponse} />
    <div className={styles.resetButton}>
      <AdacButton onClick={resetWizard} type="primary" className="margin-bottom--m">
        Zur Startseite
      </AdacButton>
    </div>
    {faqs && (
      <FAQs headline={faqs.headline} accordions={faqs.accordions} className="margin-bottom--xxl" />
    )}
  </>
);
